import { searchActions, service } from '..';
import { priceDispatcher,stockDispatcher } from '../../store';
import { AppStore } from '../../store';
import { convertToLineItem,convertToStockItem } from '../../util';

const endpoint = 'search';

export const searchService = {
  get: action => service( endpoint ).post( { query: action.query } ).then( result => { 
    if(result.data && result.data.length > 0) {
    priceDispatcher( AppStore.dispatch ).getPrices( result.data.map( product=> convertToLineItem(product, AppStore.getState().user) ) );
    stockDispatcher( AppStore.dispatch ).getStocks( result.data.map( convertToStockItem ) );
    }
    return { query: action.query, data: result.data, type: searchActions.LOAD } } )
};